// extracted by mini-css-extract-plugin
export var activityContainer = "_jh-0";
export var typingIndicatorContainer = "_jh-1";
export var typingIndicatorDot = "_jh-2";
export var wave = "_jh-3";